import { ButtonItem, Form, GroupItem, RequiredRule, SimpleItem } from 'devextreme-react/form'
import { useState } from 'react'
import '../SoftwarePage.scss'
import { ArraySourceComposer } from '@/auth/api/connector'
import LoadingPanel from '@/components/loading-panel/LoadingPanel'
import { ValueChangedEvent } from 'devextreme/ui/switch'
import notify from 'devextreme/ui/notify'
import { getApiErrorMessage } from '@/auth/api/apiErrorMessage'

export const SoftwareQsCodeComputer = (props: any) => {
  const [allSitesEnabled, setAllSitesEnabled] = useState<boolean>(props.data?.allSites)
  const [loadIndicatorVisible, setLoadIndicatorVisible] = useState(false)

  return (
    <>
      <div id="edit-qs-license-form-container" className={'dx-card responsive-paddings'}>
        <LoadingPanel
          position={{ of: '#edit-qs-license-form-container' }}
          visible={loadIndicatorVisible}
        ></LoadingPanel>
        <form
          onSubmit={async (e) => {
            e.preventDefault()
            setLoadIndicatorVisible(true)
            try {
              await props.onSubmitEditor(e, props.data)
            } catch (error: unknown) {
              notify(
                {
                  message: `Calcolo codici non riuscito: ${getApiErrorMessage(error, 'Impossibile calcolare i codici. Riprovare.')}`,
                  type: 'error',
                  displayTime: 10000,
                },
                { position: 'bottom center', direction: 'up-push' },
              )
            } finally {
              setLoadIndicatorVisible(false)
            }
          }}
        >
          <Form
            id={`swqs_codecmp_form}`}
            key={`swqs_codecmp_form}`}
            formData={props.data}
            validationGroup="qsLicenseDataValidation"
          >
            <GroupItem colCount={1}>
              <SimpleItem
                dataField="sede.azienda.nome"
                label={{ text: 'Azienda' }}
                editorOptions={{ readOnly: true }}
              />
              <SimpleItem
                dataField="sede"
                label={{ text: 'Sede' }}
                editorType="dxLookup"
                editorOptions={{
                  readOnly: allSitesEnabled,
                  dataSource: ArraySourceComposer('id', props.sedi),
                  placeholder: '*',
                  displayExpr: 'nome',
                  searchEnabled: true,
                  dropDownCentered: true,
                  dropDownOptions: {
                    showTitle: true,
                    title: 'Selezionare la sede',
                    hideOnOutsideClick: true,
                  },
                }}
              ></SimpleItem>
              <SimpleItem
                dataField="versione"
                label={{ text: 'Versione' }}
                editorType="dxLookup"
                editorOptions={{
                  dataSource: ArraySourceComposer('id', props.versioni),
                  placeholder: 'Seleziona la versione...',
                  displayExpr: 'major',
                  searchEnabled: true,
                  dropDownCentered: true,
                  dropDownOptions: {
                    showTitle: true,
                    title: 'Selezionare la versione',
                    hideOnOutsideClick: true,
                  },
                }}
              >
                <RequiredRule message="La definizione della versione è obbligatoria" />
              </SimpleItem>
              <SimpleItem
                dataField="allSites"
                label={{ text: 'Tutte le sedi' }}
                editorType="dxSwitch"
                editorOptions={{
                  onValueChanged: (e: ValueChangedEvent) => {
                    setAllSitesEnabled(e.value)
                  },
                }}
              />
              <SimpleItem dataField="updateVersions" label={{ text: 'Aggiorna versioni' }} editorType="dxSwitch" />
            </GroupItem>
            <GroupItem cssClass="last-group">
              <GroupItem cssClass="buttons-group" colCountByScreen={colGroupCountByScreen}>
                <ButtonItem
                  name="btn-compute"
                  buttonOptions={{
                    icon: 'variable',
                    text: 'Calcola',
                    disabled: false,
                    useSubmitBehavior: true,
                    width: '150px',
                  }}
                ></ButtonItem>
              </GroupItem>
            </GroupItem>
          </Form>
        </form>
      </div>
    </>
  )
}

const colGroupCountByScreen = {
  xs: 1,
  sm: 2,
  md: 2,
  lg: 2,
}

export default SoftwareQsCodeComputer
